import { Validators } from '@angular/forms';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import * as moment from 'moment';

export const retirement_date_form_template = {
    variationDate: moment(),
    currentRetirementDate: null,
    newRetirementDate: null,
};

export const retirement_date_form_validators = {
    variationDate: [Validators.required],
    currentRetirementDate: [Validators.required],
    newRetirementDate: [Validators.required],
};

export const retirement_date_form_keys: IFormKey[] = [
        {
        id: 'variation-date-field',
        label: 'Data di variazione ',
        controlName: 'variationDate',
        css: 'col-3',
        type: 'INPUT',
        minDate: moment()
    },
    {
        id: 'current-retirement-field',
        label: 'Data pensionamento',
        controlName: 'currentRetirementDate',
        css: 'col-3',
        type: 'DATEPICKER',
        readonly: true,
    },
    {
        id: 'new-retirement-field',
        label: 'Nuovo anno di pensionamento',
        controlName: 'newRetirementDate',
        type: 'DATEPICKER',
        css: 'col-4'
    }
];